import { render, staticRenderFns } from "./DefTooltip.vue?vue&type=template&id=452897a1&scoped=true"
import script from "./DefTooltip.vue?vue&type=script&lang=js"
export * from "./DefTooltip.vue?vue&type=script&lang=js"
import style0 from "./DefTooltip.vue?vue&type=style&index=0&id=452897a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452897a1",
  null
  
)

export default component.exports